<template>
  <div class="main" v-if="showModal">
    <!-- 登录 -->
    <div class="common-large-dialog-wrap" v-if="status == 'dl'">
      <div class="common-large-dialog-content">
        <div class="dialog-center-bg"></div>
        <div class="dialog-close-btn" @click="handleClose"></div>
        <div class="dialog-header">
          <div>登录注册</div>
        </div>
        <div class="login-content">
          <div class="login-dialog-box">
            <!---->
            <div class="login-form-wrap">
              <div class="form-item-box">
                <div class="input-box">
                  <img
                    src="../../../assets/images/mobile-icon.png"
                    alt=""
                    class="left-icon mobile-icon"
                  />
                  <div class="input">
                    <input
                      v-model="form.phoneNumber"
                      maxlength="11"
                      type="number"
                      placeholder="输入手机号码"
                    />
                  </div>
                </div>
              </div>

              <div class="form-item-box">
                <div class="input-box">
                  <img
                    src="../../../assets/images/safe-icon.png"
                    alt=""
                    class="left-icon code-icon"
                  />
                  <div class="input">
                    <input
                      type="password"
                      v-model="form.password"
                      id="login_code_elm"
                      placeholder="输入密码"
                      @keyup.enter="handleLogin"
                    />
                  </div>
                </div>
              </div>
              <div class="form-item-box forget-box" @click="handleGo('wjmm')">
                <div class="forget-box">忘记密码</div>
              </div>
              <div class="agree-text-box" @click="handleAgree">
                <div class="agree-check-box">
                  <img
                    v-if="select"
                    src="../../../assets/images/right-icon.png"
                    alt=""
                  />
                </div>
                <div class="text">
                  <div class="text-item">
                    已阅读并同意<span>《用户协议》</span>与<span
                      >《隐私政策》</span
                    >
                  </div>
                  <div class="text-item">
                    我已满18岁，站内所有活动均为消遣娱乐，请勿沉迷
                  </div>
                </div>
              </div>
              <div class="login-submit-btn" @click="handleLogin()">
                <span>登录</span>
              </div>
              <div class="login-tip" @click="handleGo('zc')">
                没有账号？
                <div style="color: #6796f6">去注册</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 注册 -->
    <div class="common-large-dialog-wrap" v-if="status == 'zc'">
      <div class="common-large-dialog-content">
        <div class="dialog-center-bg"></div>
        <div class="dialog-close-btn" @click="handleClose"></div>
        <div class="dialog-header">
          <div>登录注册</div>
        </div>
        <div class="login-content">
          <div class="login-dialog-box">
            <div class="login-form-wrap">
              <div class="form-item-box">
                <div class="input-box">
                  <img
                    src="../../../assets/images/mobile-icon.png"
                    alt=""
                    class="left-icon mobile-icon"
                  />
                  <div class="input">
                    <input
                      v-model="registerform.phoneNumber"
                      maxlength="11"
                      type="number"
                      placeholder="输入手机号码"
                    />
                  </div>
                </div>
              </div>

              <div class="form-item-box">
                <div class="input-box">
                  <img
                    src="../../../assets/images/mobile-icon.png"
                    alt=""
                    class="left-icon mobile-icon"
                  />
                  <div class="input">
                    <input
                      v-model="registerform.nickName"
                      maxlength="11"
                      type="text"
                      placeholder="输入昵称"
                    />
                  </div>
                </div>
              </div>

              <div class="form-item-box">
                <div class="input-box">
                  <img
                    src="../../../assets/images/safe-icon.png"
                    alt=""
                    class="left-icon code-icon"
                  />
                  <div class="input">
                    <input
                     type="password"
                      v-model="registerform.password"
                      id="login_code_elm"
                      placeholder="请输入新的密码"
                    />
                  </div>
                </div>
              </div>

              <div class="form-item-box">
                <div class="input-box">
                  <img
                    src="../../../assets/images/safe-icon.png"
                    alt=""
                    class="left-icon code-icon"
                  />
                  <div class="input">
                    <input
                      type="password"
                      v-model="registerform.confirmPassword"
                      id="login_code_elm"
                      placeholder="请输入确认密码"
                    />
                  </div>
                </div>
              </div>

              <div class="form-item-box">
                <div class="input-box">
                  <img
                    src="../../../assets/images/code.png"
                    alt=""
                    class="left-icon code-icon"
                  />
                  <div class="input">
                    <input
                      type="number"
                      v-model="registerform.code"
                      id="login_code_elm"
                      placeholder="请输入验证码"
                    />
                  </div>
                  <div class="line"></div>
                  <div @click="getyzm()" class="send-code-box">
                    <div class="send-code-box">
                      <span>{{ title }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-item-box">
                <div class="input-box">
                  <img
                    src="../../../assets/images/gift.png"
                    alt=""
                    class="left-icon code-icon"
                  />
                  <div class="input">
                    <input
                      type="text"
                      v-model="registerform.parentInvitationCode"
                      id="login_code_elm"
                      placeholder="请输入邀请码（选填）"
                    />
                  </div>
                  <!-- <div class="line"></div> -->
                  <!-- <div @click="sendCode" class="send-code-box"> -->
                  <!-- <div class="send-code-box">
                        <span>{{ countdownDesc }}</span>
                      </div> -->
                </div>
              </div>
              <div class="agree-text-box" @click="handleAgree">
                <div class="agree-check-box">
                  <img
                    v-if="select"
                    src="../../../assets/images/right-icon.png"
                    alt=""
                  />
                </div>
                <div class="text">
                  <div class="text-item">
                    已阅读并同意<span>《用户协议》</span>与<span
                      >《隐私政策》</span
                    >
                  </div>
                  <div class="text-item">
                    我已满18岁，站内所有活动均为消遣娱乐，请勿沉迷
                  </div>
                </div>
              </div>
              <div class="login-submit-btn" @click="handleRegister()">
                <span>立即注册</span>
              </div>
              <div class="login-tip" @click="handleGo('dl')">
                <div style="color: #6796f6">返回登录</div>
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-footer"></div>
      </div>
    </div>
    <!-- 忘记密码 -->
    <div class="common-large-dialog-wrap" v-if="status == 'wjmm'">
      <div class="common-large-dialog-content">
        <div class="dialog-center-bg"></div>
        <div class="dialog-close-btn" @click="handleClose"></div>
        <div class="dialog-header">
          <div>忘记密码</div>
        </div>
        <div class="login-content">
          <div class="login-dialog-box">
            <div class="login-form-wrap">
              <div class="form-item-box">
                <div class="input-box">
                  <img
                    src="../../../assets/images/mobile-icon.png"
                    alt=""
                    class="left-icon mobile-icon"
                  />
                  <div class="input">
                    <input
                      v-model="forgetform.phoneNumber"
                      maxlength="11"
                      type="number"
                      placeholder="输入手机号码"
                    />
                  </div>
                </div>
              </div>
              <div class="form-item-box">
                <div class="input-box">
                  <img
                    src="../../../assets/images/code.png"
                    alt=""
                    class="left-icon code-icon"
                  />
                  <div class="input">
                    <input
                      type="number"
                      v-model="forgetform.code"
                      id="login_code_elm"
                      placeholder="请输入验证码"
                    />
                  </div>
                  <div class="line"></div>
                  <div @click="getyzm()" class="send-code-box">
                    <div class="send-code-box">
                      <span>{{ title }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-item-box">
                <div class="input-box">
                  <img
                    src="../../../assets/images/safe-icon.png"
                    alt=""
                    class="left-icon code-icon"
                  />
                  <div class="input">
                    <input
                      type="password"
                      v-model="forgetform.password"
                      id="login_code_elm"
                      placeholder="请输入新的密码"
                    />
                  </div>
                </div>
              </div>
              <div class="form-item-box">
                <div class="input-box">
                  <img
                    src="../../../assets/images/safe-icon.png"
                    alt=""
                    class="left-icon code-icon"
                  />
                  <div class="input">
                    <input
                      type="password"
                      v-model="forgetform.confirmPassword"
                      id="login_code_elm"
                      placeholder="请输入确认密码"
                    />
                  </div>
                </div>
              </div>
              <div class="form-item-box forget-box">
                <div class="forget-box">忘记密码</div>
              </div>
              <div class="login-submit-btn" @click="handleForget()">
                <span>确认</span>
              </div>
              <div class="login-tip" @click="handleGo('dl')">
                已有账号？
                <div style="color: #6796f6">去登录</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getLogin, getRegister, getcode, changePass } from "../../../api/index";
import browser from "@/utils/brouser";
// getToken
import { setToken } from "../../../api/cookie";
import { getUserInfo } from "../../../api/index";
// import { mapState } from "vuex";
export default {
  props: {
    inviteCode: {
      type: String, 
      default: '' 
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    showModal(val) {
      if (val) {
       this.registerform.parentInvitationCode =this.inviteCode
      }
    },
  },
  data() {
    return {
      disabled: false,
      timer: null,
      second: "",
      registerform: {
        code: "",
        nickName: "",
        parentInvitationCode: "",
        password: "",
        phoneNumber: "",
        confirmPassword: "",
      },
      forgetform: {
        code: "",
        nickName: "",
        parentInvitationCode: "",
        password: "",
        phoneNumber: "",
        confirmPassword: "",
      },
      status: "dl",
      select: false,
      form: {
        code: "",
        nickName: "",
        parentInvitationCode: "",
        password: "",
        phoneNumber: "",
      },
    };
  },
  computed: {
    title() {
      return this.disabled ? `重新获取 ( ${this.second} ) s` : "获取验证码";
    },
  },
  methods: {
    playAudio() {
      this.$store.commit("playAudio");
    },
    handleForget() {
      if (this.forgetform.phoneNumber == "") {
        this.$message({ duration: 1000,
          message: "请输入新密码或手机号",
          type: "warning",
          customClass: "log_warning",
        });
        return;
      } else if (this.forgetform.password == "") {
        this.$message({ duration: 1000,
          message: "请输入密码！",
          type: "warning",
          customClass: "log_warning",
        });
      } else if (this.forgetform.password != this.forgetform.confirmPassword) {
        this.$message({ duration: 1000,
          message: "密码输入不一致，请重新输入！",
          type: "warning",
          customClass: "log_warning",
        });
      } else {
        let data = {
          code: this.forgetform.code,
          confirmPassword: this.forgetform.confirmPassword,
          password: this.forgetform.password,
          phoneNumber: this.forgetform.phoneNumber,
        };
        changePass(data).then((res) => {
          if (res.data.code == 200) {
            this.$message({ duration: 1000,
              message: "密码重置成功",
              type: "success",
              customClass: "log_success",
            });
            this.status = "dl";
          } else {
            this.$message({ duration: 1000,
              message: "验证码错误，请重试",
              type: "warning",
              customClass: "log_warning",
            });
          }
        });
      }
    },
    getyzm() {
      let dataform = {};
      if (this.disabled) {
        return false;
      }
      if (this.status == "zc") {
        if (this.registerform.phoneNumber == "") {
          this.$message({ duration: 1000,
            message: "请输入用户名或手机号",
            type: "warning",
            customClass: "log_warning",
          });
          return;
        }
        dataform.type = 1;
        dataform.phoneNumber = this.registerform.phoneNumber;
      } else if (this.status == "wjmm") {
        if (this.forgetform.phoneNumber == "") {
          this.$message({ duration: 1000,
            message: "请输入用户名或手机号",
            type: "warning",
            customClass: "log_warning",
          });
          return;
        }
        dataform.phoneNumber = this.forgetform.phoneNumber;
        dataform.type = 4;
      }
      getcode(dataform).then((res) => {
        if (res.data.code == 200) {
          let that = this;
          let s = 60; //倒计时间
          if (!that.timer) {
            that.second = s;
            that.disabled = true;
            that.timer = setInterval(() => {
              if (that.second > 0 && this.second <= s) {
                that.second--;
              } else {
                that.disabled = false;
                clearInterval(that.timer);
                this.timer = null;
              }
            }, 1000);
          }
          this.$message({ duration: 1000,
            message: `${res.data.msg}`,
            type: "success",
            customClass: "log_success",
          });
        }
        if (res.data.code == 500) {
          this.$message({ duration: 1000,
            message: `${res.data.msg}`,
            type: "warning",
            customClass: "log_warning",
          });
        }
      });
    },
    handle() {},
    handleGo(res) {
      this.status = res;
    },
    handleRegister() {
      if (this.select == false) {
        this.$message({ duration: 1000,
          message: "请点击同意用户协议",
          type: "warning",
          customClass: "log_warning",
        });
      } else {
        if (
          this.registerform.phoneNumber == "" &&
          this.registerform.nickName == ""
        ) {
          this.$message({ duration: 1000,
            message: "请输入用户名或手机号",
            type: "warning",
            customClass: "log_warning",
          });
          return;
        } else if (this.registerform.password == "") {
          this.$message({ duration: 1000,
            message: "请输入密码",
            type: "warning",
            customClass: "log_warning",
          });
        } else if (
          this.registerform.confirmPassword != this.registerform.password
        ) {
          this.$message({ duration: 1000,
            message: "两次密码不一致",
            type: "warning",
            customClass: "log_warning",
          });
        } else if (this.registerform.code == "") {
          this.$message({ duration: 1000,
            message: "请获取验证码",
            type: "warning",
            customClass: "log_warning",
          });
        } else {
          if (this.registerform.parentInvitationCode == "mkcsgo") {
            this.registerform.parentInvitationCode = "";
          }
          getRegister(this.registerform).then((res) => {
            if (res.data.code == 200) {
              this.$message({ duration: 1000,
                message: "注册成功",
                type: "success",
                customClass: "info_success",
              });
              this.status = "dl";
              // 成功清理邀请码
              this.registerform.parentInvitationCode = "";
              // 删除本地缓存邀请码
              localStorage.removeItem("inviteCode");
            } else {
              this.$message({ duration: 1000,
                message: `${res.data.msg}`,
                type: "warning",
                customClass: "warning",
              });
            }
          });
        }
      }
    },
    handleLogin() {
      if (this.select == false) {
        this.$message({ duration: 1000,
          message: "请先勾选以下协议",
          type: "warning",
          customClass: "log_warning",
        });
      } else if (this.select == true) {
        if (this.form.phoneNumber == "" && this.form.password == "") {
          this.$message({ duration: 1000,
            message: "请输入用户名或密码",
            type: "warning",
            customClass: "log_warning",
          });
          return;
        }

        let data = {
          username: this.form.phoneNumber,
          password: this.form.password,
          equipment: "1",
        };
        if (!browser().mobile) {
          // data.equipment='1'
        } else if (browser.webapp) {
          data.equipment = "2";
        } else {
          data.equipment = "1";
        }
        getLogin(data)
          .then((res) => {
            let code = res.data.code;
            if (code == "200") {
              this.handleClose();
              this.exist = 2;

              setToken(res.data.token);
              this.$store.commit("LOGIN_IS_SHOW", false);
              // this.$router.back()
              // window.history.back()
              this.$message({ duration: 1000,
                message: "登录成功",
                type: "success",
                customClass: "log_success",
              });
              //   this.close();
              //获取用户信息
              getUserInfo().then((res) => {
                if (res.data.code == 200) {
                  this.$store.commit("USER_INFO", res.data.data);
                  this.$bus.$emit("islogin", false);
                  this.$router.push("/");
                  this.$socket.send("login_userId_" + res.data.data.userId);
                  // 关闭连接
                  this.$socket.close();
                }
              });
            }
          })
          .catch((err) => {
            throw new Error(err.message);
          });
      }
    },
    handleClose() {
      console.log("关闭");
      this.$soundPlay("dialogClose");
      this.$emit("close");
    },
    handleAgree() {
      this.$nextTick(() => {
        this.select = !this.select;
        // console.log(this.select, "阿吉大大");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
  height: 100vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
}
.common-large-dialog-wrap {
  border: none;
}

.common-large-dialog-wrap .van-dialog__content {
  padding-bottom: 9.87 * 4.2px;
}

.common-large-dialog-wrap .common-large-dialog-content {
  width: 100%;
  min-height: 77.6 * 4.2px;
  background: url("../../../assets/images/large_dialog_top3.png") no-repeat top
      center / 99% 11.73 * 4.2px,
    url("../../../assets/images/k26.png") no-repeat bottom center / 99% 16.67 *
      4.2px;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.common-large-dialog-wrap .common-large-dialog-content .dialog-center-bg {
  position: absolute;
  top: 11.73 * 4.2px;
  left: 0;
  width: 100%;
  height: -webkit-calc(100% - 28.13 * 4.2px);
  height: calc(100% - 28.13 * 4.2px);
  background: url("../../../assets/images/line7.png") repeat-y;
  background-position-x: center;
  background-size: 99% 1.33 * 4.2px;
}

.common-large-dialog-wrap .common-large-dialog-content .dialog-close-btn {
  width: 14 * 4.2px;
  height: 7.73 * 4.2px;
  position: absolute;
  top: 2.67 * 4.2px;
  right: 3.47 * 4.2px;
  z-index: 10;
}

.common-large-dialog-wrap .common-large-dialog-content .dialog-header {
  width: 100%;
  height: 11.73 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-family: "Alimama ShuHeiTi", serif;
  font-size: 5.6 * 4.2px;
  color: #ffffff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
}

.common-large-dialog-wrap
  .common-large-dialog-content
  .dialog-header
  .header-line-img {
  width: 87.47 * 4.2px;
  height: 0.67 * 4.2px;
  position: absolute;
  left: 6.27 * 4.2px;
  top: 15.33 * 4.2px;
}

.common-large-dialog-wrap .common-large-dialog-content .login-content {
  position: relative;
  width: 100%;
  height: auto;
  min-height: 66.67 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: unset;
  background-image: unset;
}

.common-large-dialog-wrap .common-large-dialog-content .dialog-footer {
  width: 100%;
  height: 50px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.login-dialog-box .van-dialog__content {
  padding-top: 14 * 4.2px;
}

.login-dialog-box .error-tip-box {
  width: 49.33 * 4.2px;
  height: 9.33 * 4.2px;
  line-height: 9.33 * 4.2px;
  background: url("../../../assets/images/error_tip_box.png") no-repeat 0 0;
  background-size: 49.33 * 4.2px 9.33 * 4.2px;
  position: absolute;
  left: 50%;
  margin-left: -24.67 * 4.2px;
  top: 0;
  color: #ffffff;
  font-size: 4.4 * 4.2px;
  text-align: center;
}

.login-dialog-box .login-form-wrap {
  width: 100%;
  height: auto;
  min-height: 66.67 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-bottom: 8.27 * 4.2px;
  padding-top: 10.4 * 4.2px;
  color: #ffffff;
}

.login-dialog-box .login-form-wrap .form-item-box {
  width: 74.93 * 4.2px;
  height: auto;
  margin: 0 auto;
  margin-bottom: 20px;
}
.login-dialog-box .login-form-wrap .form-item-box.forget-box{
  margin-bottom: 0px;
}
.login-dialog-box .login-form-wrap .form-item-box .forget-box{
  width: 100%;
  text-align: right;
  font-size: 16px;
  color: #6796f6;
}
.login-dialog-box .login-form-wrap .form-item-box:last-of-type {
  margin-bottom: 0px;
}

.login-dialog-box .login-form-wrap .form-item-box .input-box {
  width: 74.93 * 4.2px;
  height: 11.2 * 4.2px;
  background: url("../../../assets/images/input_bg.png") no-repeat 0 0;
  background-size: 74.93 * 4.2px 11.2 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.login-dialog-box .login-form-wrap .form-item-box .input-box .left-icon {
  margin: 0 4.93 * 4.2px 0 4.53 * 4.2px;
}

.login-dialog-box .login-form-wrap .form-item-box .input-box .mobile-icon {
  width: 2.93 * 4.2px;
  height: 5.07 * 4.2px;
}

.login-dialog-box .login-form-wrap .form-item-box .input-box .code-icon {
  width: 3.6 * 4.2px;
  height: 4.4 * 4.2px;
}

.login-dialog-box .login-form-wrap .form-item-box .input-box .input {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 11.2 * 4.2px;
}

.login-dialog-box .login-form-wrap .form-item-box .input-box .input input {
  width: 100%;
  height: 100%;
  font-size: 3.33 * 4.2px;
  background: transparent !important;
  color: #ffffff;
}

.login-dialog-box
  .login-form-wrap
  .form-item-box
  .input-box
  .input
  input::-webkit-input-placeholder {
  color: #7a7a7a;
}

.login-dialog-box
  .login-form-wrap
  .form-item-box
  .input-box
  .input
  input::-moz-placeholder {
  color: #7a7a7a;
}

.login-dialog-box
  .login-form-wrap
  .form-item-box
  .input-box
  .input
  input::-ms-input-placeholder {
  color: #7a7a7a;
}

.login-dialog-box
  .login-form-wrap
  .form-item-box
  .input-box
  .input
  input::placeholder {
  color: #7a7a7a;
}

.login-dialog-box .login-form-wrap .form-item-box .input-box .line {
  width: 0.4 * 4.2px;
  height: 6.67 * 4.2px;
  background: url("../../../assets/images/line8.png") no-repeat 0 0;
  background-size: 0.4 * 4.2px 6.67 * 4.2px;
  margin: 0 4 * 4.2px 0 3.2 * 4.2px;
}

.login-dialog-box .login-form-wrap .form-item-box .input-box .send-code-box {
  width: 21.33 * 4.2px;
  height: 8 * 4.2px;
  line-height: 8 * 4.2px;
  text-align: center;
  margin-right: 3.6 * 4.2px;
  color: #ffffff;
  font-size: 9.986px;
}

.login-dialog-box
  .login-form-wrap
  .form-item-box
  .input-box
  .send-code-box
  span {
  text-decoration: underline;
  letter-spacing: 1px;
}

.login-dialog-box .login-form-wrap .row {
  width: 74.93 * 4.2px;
  height: 10.27 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0 auto;
}

.login-dialog-box .login-form-wrap .agree-text-box {
  width: 74.93 * 4.2px;
  height: auto;
  margin: 0 auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  color: #ffffff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-top: 3.73 * 4.2px;
}

.login-dialog-box .login-form-wrap .agree-text-box .agree-check-box {
  width: 5.33 * 4.2px;
  height: 5.33 * 4.2px;
  background: url("../../../assets/images/k27.png") no-repeat 0 0;
  background-size: 5.33 * 4.2px 5.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin-right: 2.67 * 4.2px;
}

.login-dialog-box .login-form-wrap .agree-text-box .agree-check-box img {
  width: 3.73 * 4.2px;
  height: 2.27 * 4.2px;
}

.login-dialog-box .login-form-wrap .agree-text-box .text {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding-top: 1.33 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: left;
}

.login-dialog-box .login-form-wrap .agree-text-box .text .text-item {
  margin-bottom: 2.13 * 4.2px;
  font-size: 2.67 * 4.2px;
}

.login-dialog-box .login-form-wrap .agree-text-box .text text {
  color: #6796f6;
}

.login-dialog-box .login-form-wrap .login-submit-btn {
  width: 42.67 * 4.2px;
  height: 12.8 * 4.2px;
  background: url("../../../assets/images/submit_btn_bg.png") no-repeat 0 0;
  background-size: 42.67 * 4.2px 12.8 * 4.2px;
  margin: 7.87 * 4.2px auto 0 auto;
  font-size: 5.6 * 4.2px;
  color: #ffffff;
  text-align: center;
  line-height: 12.8 * 4.2px;
  letter-spacing: 2.13 * 4.2px;
}

.login-dialog-box .login-form-wrap .login-tip {
  width: 100%;
  height: auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 4.33 * 4.2px;
  margin: 5.07 * 4.2px auto 0 auto;
}

.login-dialog-box .login-form-wrap .login-tip span {
  color: #6796f6;
}

.login-dialog-box .login-form-wrap .steam-login-box {
  width: 100%;
  height: auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding-top: 6.93 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.login-dialog-box .login-form-wrap .steam-login-box .steam-login-inner {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 6.67 * 4.2px;
}

.login-dialog-box .login-form-wrap .steam-login-box .steam-login-inner img {
  width: 6.67 * 4.2px;
  height: 6.67 * 4.2px;
  margin-right: 3.2 * 4.2px;
}
/* 覆盖自动填充背景颜色 */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    background-color: transparent !important; /* 设置为您想要的背景色 */
    -webkit-text-fill-color: #fff !important; /* 设置文本颜色，避免与背景色冲突 */
    transition: background-color 5000s ease-in-out 0s; /* 防止背景色闪烁 */
}
/* 可选：如果您还希望改变下拉列表按钮的外观 */
input:-webkit-autofill::-webkit-calendar-picker-indicator {
    filter: invert(1); /* 反转颜色，使图标更清晰 */
}
</style>
